import React from 'react';
import AtlasV2DorisDoubleDropdownChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisDoubleDropdownChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { useDorisEntityDropdownOptions } from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TotalTrafficDoubleDropdownTopEntity';
import { GroupByField } from 'src/components/AtlasV2Components/AtlasV2TrafficV2PageComponents/AtlasV2TotalTrafficV2/AtlasV2TrafficDropdownTopEntityTraffic';
import { DorisDropdownFieldNameEnum } from 'src/components/AtlasV2Components/Consts/DorisFieldNameEnum';
import { useSalesCustomGroupBy } from 'src/components/AtlasV2Components/Hooks/useSalesCustomGroupBy';
import { createLabelCaseProcessor } from 'src/components/AtlasV2Components/utils/chartDataTransformUtils';

const AtlasSalesDoubleDropdownTopEntityChart = ({
  groupByFields,
  enableSearchableGroupBy
}: {
  groupByFields?: GroupByField[];
  enableSearchableGroupBy?: boolean;
}) => {
  const dropdownOptions = useDorisEntityDropdownOptions(DorisDropdownFieldNameEnum.Sales);

  // Toggle condition here

  const { computedGroupByFields, selectedGroupByField, additionalParams, renderGroupBySelector } =
    useSalesCustomGroupBy({
      enabled: enableSearchableGroupBy,
      groupByFields: (groupByFields || dropdownOptions) as GroupByField[]
    });

  // Use shared utility to create preProcessData function - Product tagging data want to be lowercased
  const preProcessData = createLabelCaseProcessor(selectedGroupByField);

  return (
    <AtlasV2DorisDoubleDropdownChart
      groupByFields={computedGroupByFields}
      selectedGroupByField={selectedGroupByField}
      fields={[
        {
          fieldName: 'retailSales',
          label: 'Retail Sales',
          metricType: 'retailSales',
          metricTypeDisplay: METRICTYPE.MONEY
        },
        {
          fieldName: 'firstPartySales',
          label: '1P Retail Sales',
          metricType: 'firstPartySales',
          metricTypeDisplay: METRICTYPE.MONEY
        },
        {
          fieldName: 'thirdPartySales',
          label: '3P Retail Sales',
          metricType: 'thirdPartySales',
          metricTypeDisplay: METRICTYPE.MONEY
        }
      ]}
      queryKey="sales_doubleDropdownTopEntityChart"
      endPoint="sales/GetSalesMetrics"
      additionalParams={additionalParams}
      renderGroupBySelector={renderGroupBySelector}
      preProcessData={preProcessData}
    />
  );
};
export default AtlasSalesDoubleDropdownTopEntityChart;
